import styled from "@emotion/styled";
import { useIsMobile } from "hooks/useDeviceType";

interface NoTradesDisplayContainerProps {
  isConnectWallet?: boolean;
}

export const NoTradesDisplayContainer = styled.div<NoTradesDisplayContainerProps>(
  ({ theme, isConnectWallet }) => {
    const isMobile = useIsMobile();
    return {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: isConnectWallet ? "16px" : "none",
      borderRadius: "25px",
      width: isMobile ? "284px" : "352px",
      margin: "auto",
      padding: "40px",
      boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.5), 0px 1px 15px 0px rgba(0, 0, 0, 0.25)",
    };
  }
);
